import React, { useContext, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { MemberRequestContext } from '../MemberRequestComponent';
import { deleteMemberRequestAction } from '../../../Redux/Action/MemberAction';

function MemberRequestDeleteWarning() {
    // hooks
    const deleteBtnRef = useRef()
    const dispatch = useDispatch()

    const { getSingleMemberData, setRejectModal, setForceToFetchData } = useContext(MemberRequestContext)

    // delete on click
    const deleteOnClick = () => {
        const payload = {
            data: {
                request_id: getSingleMemberData.id
            },
            deleteBtnRef,
            setForceToFetchData,
            setRejectModal
        }

        dispatch(deleteMemberRequestAction(payload))
    }
    return (
        <>
            <p className="mb-2 text-center">
                Are you sure you want to reject this member request?
            </p>
            <p className="text-muted text-center" >
                This action cannot be undone.
            </p>

            <div className=' d-flex align-items-center justify-content-center'>
                <Button onClick={(e) => { deleteOnClick() }} ref={deleteBtnRef} className='btn-danger me-2'>Yes</Button>
                <Button onClick={(e) => { setRejectModal(false) }}>No</Button>
            </div>
        </>
    );
}

export default MemberRequestDeleteWarning;